export const actions = {
    GET_SAVED_CARDS: 'GET_SAVED_CARDS',
    GET_SAVED_CARDS_SUCCESS: 'GET_SAVED_CARDS_SUCCESS',
    GET_SAVED_CARDS_FAILED: 'GET_SAVED_CARDS_FAILED',
    ADD_CARD: 'ADD_CARD',
    ADD_CARD_SUCCESS: 'ADD_CARD_SUCCESS',
    ADD_CARD_FAILED: 'ADD_CARD_FAILED',
    REMOVE_CARD: 'REMOVE_CARD',
    REMOVE_CARD_SUCCESS: 'REMOVE_CARD_SUCCESS',
    REMOVE_CARD_FAILED: 'REMOVE_CARD_FAILED',
    SELECT_CARD: 'SELECT_CARD',
    DEFAULT_CARD: 'DEFAULT_CARD',
    RESET_WALLET: 'RESET_WALLET',
    CLEAR_CARD_ERROR: 'CLEAR_CARD_ERROR',

    // GET_BRAINTREE_CLIENT_TOKEN: 'GET_BRAINTREE_CLIENT_TOKEN',
    // GET_BRAINTREE_CLIENT_TOKEN_SUCCESS: 'GET_BRAINTREE_CLIENT_TOKEN_SUCCESS',
    // GET_BRAINTREE_CLIENT_TOKEN_FAILURE: 'GET_BRAINTREE_CLIENT_TOKEN_FAILURE',

    ADD_PAYPAL_PAYMENT_METHOD: 'ADD_PAYPAL_PAYMENT_METHOD',
    ADD_PAYPAL_PAYMENT_METHOD_SUCCESS: 'ADD_PAYPAL_PAYMENT_METHOD_SUCCESS',
    ADD_PAYPAL_PAYMENT_METHOD_FAILED: 'ADD_PAYPAL_PAYMENT_METHOD_FAILED',

    SAVE_SELECTED_PAYMENT_METHOD_SUCCESS: 'SAVE_SELECTED_PAYMENT_METHOD_SUCCESS',
    SAVE_SELECTED_PAYMENT_METHOD_FAILED: 'SAVE_SELECTED_PAYMENT_METHOD_FAILED',

    SET_LAST_SUBSCRIPTION_RENEWAL_DATE: 'SET_LAST_SUBSCRIPTION_RENEWAL_DATE',
    SET_CARD_LINKED_TO_SUBSCRIPTION: 'SET_CARD_LINKED_TO_SUBSCRIPTION',
}

export const getSavedCards = () => ({
    type: actions.GET_SAVED_CARDS,
})

export const getSavedCardsSuccess = cards => ({
    type: actions.GET_SAVED_CARDS_SUCCESS,
    payload: cards,
})

export const getSavedCardsFailed = error => ({
    type: actions.GET_SAVED_CARDS_FAILED,
    payload: error,
})

export const addCard = (card, zip, subscriptions) => ({
    type: actions.ADD_CARD,
    payload: { token: card, zip, subscriptions },
})

export const addCardSuccess = () => ({
    type: actions.ADD_CARD_SUCCESS,
})

export const addCardFailed = (errorMessage, status) => ({
    type: actions.ADD_CARD_FAILED,
    payload: {
        errorMessage,
        status,
    },
})

export const removeCard = card => ({
    type: actions.REMOVE_CARD,
    payload: card,
})

export const removeCardSuccess = () => ({
    type: actions.REMOVE_CARD_SUCCESS,
})

export const removeCardFailed = (errorMessage, status) => ({
    type: actions.REMOVE_CARD_FAILED,
    payload: {
        errorMessage,
        status,
    },
})

export const clearCardError = () => ({
    type: actions.CLEAR_CARD_ERROR,
})

export const selectCard = card => ({
    type: actions.SELECT_CARD,
    payload: card,
})

export const defaultCard = card => ({
    type: actions.DEFAULT_CARD,
    payload: card,
})

export const resetWallet = () => ({
    type: actions.RESET_WALLET,
})

export const addPaypalPayment = response => ({
    type: actions.ADD_PAYPAL_PAYMENT_METHOD,
    payload: response,
})

export const addPaypalPaymentSuccess = token => ({
    type: actions.ADD_PAYPAL_PAYMENT_METHOD_SUCCESS,
    payload: token,
})

export const addPaypalPaymentFailed = error => ({
    type: actions.ADD_PAYPAL_PAYMENT_METHOD_FAILED,
    payload: error,
})

export const saveSelectedPaymentMethodSuccess = () => ({
    type: actions.SAVE_SELECTED_PAYMENT_METHOD_SUCCESS,
})

export const saveSelectedPaymentMethodFailed = error => ({
    type: actions.SAVE_SELECTED_PAYMENT_METHOD_FAILED,
    payload: error,
})

export const setLastSubscriptionRenewalDate = date => ({
    type: actions.SET_LAST_SUBSCRIPTION_RENEWAL_DATE,
    payload: date,
})

export const setCardLinkedToSubscription = data => ({
    type: actions.SET_CARD_LINKED_TO_SUBSCRIPTION,
    payload: data,
})
